import { render, staticRenderFns } from "./PublicTable.vue?vue&type=template&id=04a68a8c&scoped=true&"
import script from "./PublicTable.vue?vue&type=script&lang=js&"
export * from "./PublicTable.vue?vue&type=script&lang=js&"
import style0 from "./PublicTable.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PublicTable.vue?vue&type=style&index=1&id=04a68a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a68a8c",
  null
  
)

export default component.exports